export class CMEDRoutes {
  public static MARKET_DATA = "/cmed/market-data";
  public static ORDER_BOOK = "/cmed/order-book";
  public static BLOCK_FEED = "/cmed/block-feed";
  public static OPTIONS_GRID = "/cmed/options-grid";
  public static QUICK_STRIKE = "/cmed/quik-strike";
}
